export default {
  REACT_APP_API_ENDPOINT: "https://warm-plains-18825.herokuapp.com",
};
